import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import WaiterLayout from "../../layouts/WaiterLayout/WaiterLayout";
import DashboardWaiter from "../../components/Waiter/DashboardWaiter/DashboardWaiter";
import NotificationWaiterContext from "../../context/Waiter/NotificationWaiterContext/NotificationWaiterContext";
import NotificationWaiter from "../../components/Waiter/NotificationWaiter/NotificationWaiter";
import NotFoundPage from "../../components/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const WaiterContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[1])
    return <Navigate to="/" replace />;

  return (
    <WaiterLayout>
      <Routes>
        {/* Dashboard */}
        <Route index element={<DashboardWaiter />} />
        {/* Notification */}
        <Route
          path="/notification"
          element={
            <NotificationWaiterContext>
              <NotificationWaiter />
            </NotificationWaiterContext>
          }
        />
        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </WaiterLayout>
  );
};

export default WaiterContainer;
